/* Publish by EComposer at 2026-10-07 08:26:58*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mfkfd4iu5rf"]=  window.__ectimmers["ecom-mfkfd4iu5rf"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-mfkfd4iu5rf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfkfd4iu5rf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d8btaaya5on').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d8btaaya5on', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h481vbyo90h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h481vbyo90h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o59zk1sv9u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o59zk1sv9u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z13vu6khiw9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z13vu6khiw9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lq9cgsqz8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lq9cgsqz8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65wv88n4rz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65wv88n4rz9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-acrlz2kn52m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-acrlz2kn52m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-psu072lg95l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-psu072lg95l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e84xrp1ydy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e84xrp1ydy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37xkxpf3lup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37xkxpf3lup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a0ktq9ueq7d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0ktq9ueq7d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8as8p3gsiyv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8as8p3gsiyv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdrglkxo34e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdrglkxo34e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qv0u8l70qtb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qv0u8l70qtb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ddz3yxilm4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddz3yxilm4b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4li0j2725yr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4li0j2725yr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yn64qs2qxgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yn64qs2qxgo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7e6ol6injgk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7e6ol6injgk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ve5dhaw0nj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ve5dhaw0nj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvobhqpl5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvobhqpl5r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c8icoys6l3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c8icoys6l3', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}